import _ from 'lodash';

import { FINANCIAL_INFO_VIEWS_PATHS } from '../../tabs/financialInfo/FinancialInfo.constants';
import { getConfigFields as getAssetConfigFields } from '../../tabs/financialInfo/UpdateTableModal/Content/SectionContent/Assets/Assets.config';
import { getConfigFields as getIncomeConfigFields } from '../../tabs/financialInfo/UpdateTableModal/Content/SectionContent/EmploymentAndIncome/EmploymentAndIncome.config';
import { getConfigFields as getLiabilityConfigFields } from '../../tabs/financialInfo/UpdateTableModal/Content/SectionContent/Liabilities/Liabilities.config';
import { getConfigFields as getReoConfigFields } from '../../tabs/financialInfo/UpdateTableModal/Content/SectionContent/Reo/Reo.config';

import { extractSearchableFields } from './fields.utils';
import {
  getAssetLabel,
  getAssetName,
  getIncomeLabel,
  getIncomeName,
  getLiabilityLabel,
  getLiabilityName,
} from './records.labels';

const SEARCH_EXTRACTION_PARAMS = { recordId: 'search', ownersOptions: [], isNewRecord: false };

export const RECORD_FIELD_DEFINITIONS = {
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: extractSearchableFields(
    getLiabilityConfigFields(SEARCH_EXTRACTION_PARAMS),
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: extractSearchableFields(
    getIncomeConfigFields({ ...SEARCH_EXTRACTION_PARAMS, onChangeTaxFillingType: _.noop }),
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: extractSearchableFields(
    getAssetConfigFields({
      ...SEARCH_EXTRACTION_PARAMS,
      isVerified: false,
      onChangeAssetType: _.noop,
    }),
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: extractSearchableFields(
    getReoConfigFields({ ...SEARCH_EXTRACTION_PARAMS, isSubjectProperty: false }),
  ),
};

export const RECORD_TYPE_CONFIGS = [
  {
    dataKey: 'liabilities',
    tablePath: FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES,
  },
  {
    dataKey: 'incomes',
    tablePath: FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT,
  },
  {
    dataKey: 'assets',
    tablePath: FINANCIAL_INFO_VIEWS_PATHS.ASSETS,
  },
  {
    dataKey: 'properties',
    tablePath: FINANCIAL_INFO_VIEWS_PATHS.REO,
  },
];

export const RECORD_TYPE_LABEL_FNS = {
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: {
    getNameFn: getLiabilityName,
    getLabelFn: getLiabilityLabel,
  },
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: {
    getNameFn: getIncomeName,
    getLabelFn: getIncomeLabel,
  },
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: {
    getNameFn: getAssetName,
    getLabelFn: getAssetLabel,
  },
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: {
    getNameFn: property => property.address || 'Unknown Address',
    getLabelFn: property => property.address || 'Unknown Address',
  },
};
